import { render, staticRenderFns } from "./skill-item.vue?vue&type=template&id=6b1a6ae0&scoped=true&"
import script from "./skill-item.vue?vue&type=script&lang=js&"
export * from "./skill-item.vue?vue&type=script&lang=js&"
import style0 from "./skill-item.vue?vue&type=style&index=0&id=6b1a6ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a6ae0",
  null
  
)

export default component.exports